<template>
  <div>
  <!-- <div class="search-vessel-suffix-hidden" v-bind:class="{'div-frac-13-avg':!isMobileScreen,'div-frac-1':isMobileScreen}">
    <el-form-item label="Search Vessel" v-if="!isVesselTBC" >
      <el-select
        :filter-method=" (val)=>$emit('handleSearchMpaReceivingVessels',val) "
        filterable
        popper-class="custom-ship-selector"
        v-model="searchKey"
        style="width:100%;"
        :disabled="disabled"
        @visible-change="$emit('searchVesselvisibleChange',$event) "
        @change="$emit('handleSelectVessel',$event) "
        placeholder="Select">
        <div class="header" >
          <span >Name</span>
          <span >IMO</span>
          <span >Licence</span>
          <span >Call Sign</span>
          <span >GRT</span>
          <span >Supply Type</span>
        </div>
        <el-option
          v-for="item in searchedVesselList"
          :key="item.id"
          :label="item.shipName"
          :value="item.id">
            <div class="body">
              <span >{{item.shipName}} </span>
              <span >{{item.imo}}</span>
              <span >{{item.licenceNo}}</span>
              <span >{{item.callSign}}</span>
              <span >{{item.grt}}</span>
              <span >{{item.supplyType}}</span>
            </div>
        </el-option>
      </el-select>
    </el-form-item>
  </div> -->
  
  <div>
    <!-- Popover Vessel Search -->
    <el-form-item label="Search Vessel" v-if="!isVesselTBC">
      <div style="display: flex; gap: 8px; align-items: center;">
        <el-popover
          placement="bottom-start"
          width="700"
          trigger="click"
          v-model:visible="popoverVisible"
        >
          <div style="padding: 10px;">
            <!-- Search Input + Button -->
            <div style="display: flex; gap: 8px; align-items: center;">
              <el-input
                v-model="searchKey"
                placeholder="Search by Name, IMO or License Number"
                size="small"
                clearable
                style="flex: 1"
                :disabled="disabled"
              />
              <el-button
                size="small"
                type="primary"
                round
                :loading="searchLoading"
                @click="handleSearch()"
              >
                Search
              </el-button>
            </div>
            <div style="margin-top: 5px;">
              Result from MPA database:
            </div>

            <!-- Header -->
            <div v-if="searchedVesselList.length" class="header" style="display: flex; font-weight: bold; margin-top: 5px;">
              <span style="flex: 2;">Name</span>
              <span style="flex: 1;">IMO</span>
              <span style="flex: 1;">License</span>
              <span style="flex: 1;">Call Sign</span>
              <span style="flex: 1;">GRT</span>
              <span style="flex: 1;">Supply Type</span>
            </div>

            <!-- Scrollable vessel list -->
            <div v-loading="searchLoading" style="max-height: 200px; overflow-y: auto; margin-top: 5px;">
              <template v-if="searchedVesselList.length">
                <div
                  v-for="item in searchedVesselList"
                  :key="item.id"
                  class="body hover-row"
                  style="display: flex; padding: 6px; cursor: pointer;"
                  @click="handleSelect(item)"
                >
                  <span style="flex: 2;">{{ item.shipName }}</span>
                  <span style="flex: 1;">{{ item.imo }}</span>
                  <span style="flex: 1;">{{ item.licenceNo }}</span>
                  <span style="flex: 1;">{{ item.callSign }}</span>
                  <span style="flex: 1;">{{ item.grt }}</span>
                  <span style="flex: 1;">{{ item.supplyType }}</span>
                </div>
              </template>
              <template v-else>
                <div
                  style="height: 200px; display: flex; justify-content: center; align-items: center; color: #999;"
                >
                  No results found
                </div>
              </template>
            </div>

            <!-- Manual Add -->
            <div style="text-align: center; margin-top: 10px;" v-if="showManualAddVesselBtn">
              <span>Can't find your ship?</span><br />
              <el-button size="mini" round @click="$emit('handleAddVesselDialog',true)" type="primary">+ Manually Add Vessel</el-button>
            </div>
          </div>

          <el-button
            slot="reference"
            type="primary"
            plain
            size="mini"
            style="width: 100%"
            :disabled="disabled"
          >
            Search Vessel
          </el-button>
        </el-popover>
        <el-button
          type="primary"
          plain
          size="mini"
          :disabled="disabled"
          v-if="vesselInfoModifyDisabled"
          @click="handleAddVesselDialog()"
        >
          Modify Vessel
        </el-button>
      </div>
    </el-form-item>
  </div>
  <div v-bind:class="{'div-frac-13-avg':!isMobileScreen,'div-frac-1':isMobileScreen}" class="imo-format-error">
    <el-form-item label="IMO No." prop="vesselImoNo" :rules="rules.vesselImoNo">
      <el-input v-model="orderForm.vesselImoNo" :disabled="true" @change="(val) => $emit('handelGetVessel', val, 'imo')" />
    </el-form-item>

    <el-form-item label="License No."  prop="vesselLicenseNo" :rules="LICENSE_NUMBKER_RULE" class="imo-format-error">
      <el-input v-model="orderForm.vesselLicenseNo" :disabled="true" @change="(val) => $emit('handelGetVessel', val, 'licenceNo')" />
    </el-form-item>

    <el-form-item label="Vessel Name"  prop="vesselName" :rules="!isVesselTBC ?rules.reqRule:rules.notReqRule">
      <el-input v-model="orderForm.vesselName" :disabled="true"/>
      <div
        v-if="selectedVessel"
        class="warning-message"
      >
        <div v-if="selectedVessel.lastSyncedMpaBargeFound || selectedVessel.lastSyncedMpaVesselFound">
          Exist in MPA
        </div>
        <div v-else-if="selectedVessel.lastSyncedMpaBargeFound === false && selectedVessel.lastSyncedMpaVesselFound === false">
          Not in MPA
        </div>
      </div>
      <div
        v-if="showDBvesselName"
        style="
          position: absolute;
          top: -20px;
          right: 0;
          font-size: 8px;
          color: red;
        "
      >
        Vessel Name in Database: {{ orderForm.vesselNameDatabase }}
      </div>
    </el-form-item>
  </div>
</div>

</template>

<script>
import {mapState} from 'vuex';
import { ORDER_VIEW ,LICENSE_NUMBKER_RULE,} from '@/constants.js'
export default {
  name: 'SearchAndCreateVesselBlock',
  props:{
    disabled:Boolean,
    isVesselTBC: Boolean,
    currentView: String,
    searchedVesselList: Array,
    orderForm: Object,
    rules: Object,
    vesselInfoModifyDisabled:{
      type: String,
      default: null
    },
    selectedVessel:{
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapState([
      'isMobileScreen',

    ]),
    showDBvesselName() {
      const vesselName = this.orderForm?.vesselName;
      const vesselNameDatabase = this.orderForm?.vesselNameDatabase;
      return (
        vesselNameDatabase &&
        vesselName.trim() !== vesselNameDatabase.trim()
      );
      // return this.schedulFormData.vesselNameDatabase && this.schedulFormData.vesselName !== this.schedulFormData.vesselNameDatabase
      // return (this.schedulFormData?.vesselNameDatabase || this.schedulFormData.vesselName) && this.schedulFormData.vesselName !== this.schedulFormData.vesselNameDatabase
    },
  },
  data () {
    return {
      ORDER_VIEW,
      LICENSE_NUMBKER_RULE,
      searchKey: this.$props?.orderForm?.vesselName??'',
      showManualAddVesselBtn: false,
      popoverVisible: false,
      searchLoading:false,

      // isVesselSelected: false,
      // showAddVesselDialog: false,
      // isCreateNewVessel: false,
      // selectedVessel: {},
    }
  },
  watch: {
    popoverVisible(val) {
      if (!val) {
        this.$nextTick(() => {
          document.activeElement?.blur();
        });
      }
    },
    searchedVesselList(newList) {
      this.searchLoading = false;
      this.showManualAddVesselBtn = true;
    }
  },
  methods:{
    handleSearch(){
      this.searchLoading = true
      this.$emit('handleSearchMpaReceivingVessels', this.searchKey);
    },
    handleSelect(item) {
      this.$emit('handleSelectVessel', item.id)
      // this.selectedVessel = item
      // this.isVesselSelected = true
      this.popoverVisible = false
    },
    handleAddVesselDialog(){
      this.popoverVisible = false
      this.$emit('handleAddVesselDialog',false)
    }
  },
}
</script>
<style lang="scss" scoped>
.select-body {
  display: grid;
  column-gap: 4px;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr
}
.header, .body {
  display: grid;
  column-gap: 4px;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr
}
.header{
  padding:10px;
  span{
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
  }
 }
.body{
    span{
      display: inline-block;
      font-size: 12px;
      font-weight: 400;
    }
 }

@media screen and (max-width: 599px) {
  .header{
    span{
      font-size: 12px;
    }
  }
.body{
    span{
      font-size: 11px;
    }
 }

}

/deep/.imo-format-error .el-form-item__error {
  color: #256BC3 !important;
}

.hover-row {
  transition: background-color 0.2s ease;
}
.hover-row:hover {
  background-color: #f5f7fa;
}

.warning-message {
  color: #256BC3; 
  font-size: 10px; 
  margin: -10px 0px;
}
</style>
